import React, { memo } from 'react'

import classNames from 'classnames'

import { fontFamily } from 'root/src/client/web/commonStyles'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = {
	fontStyle: {
		fontFamily,
		fontSize: 20,
		fontWeight: 500,
		lineHeight: 1.5,
	},
}

export const HeaderUnstyled = memo((({ classes, children, className }) => (
	<div className={classNames(classes.fontStyle, className)}>
		{children}
	</div>
)))

export default withStyles(styles, { name: 'MuiHeaderUnstyled' })(HeaderUnstyled)
